import React from 'react';
import Hero from './components/act-mission-shakti/Hero';
import Main from './components/act-mission-shakti/Main';

const ActMissionShakti = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ActMissionShakti;